import React, { PureComponent } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { server } from "../env";
import api from "../tools/api";

export default class Sidebar extends PureComponent {
  state = {
    tab: window.location.href.split("/")[3] || "/",
    discord: "",
    showProducts: false,
    showPricing: false,
    access: {},
  };

  logout = () => {
    Cookies.remove("token");
    window.location.href = "/login";
  };

  componentDidMount = async () => {
    this.setState({
      access: await api.getAccess(),
    });
    await axios.get(server + "/v1/social_media/read").then((rsp) => {
      rsp.data.payload.forEach((element) => {
        if (element.name === "discord") {
          this.setState({
            discord: element.url,
          });
        }
      });
    });
  };

  render() {
    const { tab, discord, access } = this.state;
    return (
      <nav
        className="navbar navbar-vertical fixed-start navbar-expand-md navbar-light"
        id="sidebar"
      >
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapse"
            aria-controls="sidebarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <Link className="navbar-brand" to="/">
            <img
              src={
                localStorage.getItem("themeMode") === "light"
                  ? "/assets/img/logo 2.png"
                  : "/assets/img/logo 1.png"
              }
              className="navbar-brand-img mx-auto"
              alt="..."
            />
          </Link>

          <div className="navbar-user d-md-none">
            <div className="dropdown">
              <Link
                to="#"
                id="sidebarIcon"
                className="dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div className="avatar avatar-sm avatar-online">
                  <img
                    src="/assets/img/avatars/user.png"
                    className="avatar-img rounded-circle"
                    alt="..."
                  />
                </div>
              </Link>

              <div
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="sidebarIcon"
              >
                <Link to="/settings" className="dropdown-item">
                  Settings
                </Link>
                <hr className="dropdown-divider" />
                <Link to="#" onClick={this.logout} className="dropdown-item">
                  Logout
                </Link>
              </div>
            </div>
          </div>

          <div className="collapse navbar-collapse" id="sidebarCollapse">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  className={tab === "/" ? "nav-link active" : "nav-link"}
                  onClick={() => this.setState({ tab: "/" })}
                  to="/"
                >
                  <i className="fe fe-layout"></i> Dashboard
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#products"
                >
                  <i className="fe fe-package"></i> Products
                </Link>
                <div className="collapse" id="products">
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <Link to="/product/datacenter" className="nav-link">
                        Datacenter Proxies
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link to="/product/residential" className="nav-link">
                        Residential Proxies
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link
                        to="/product/premium-residential"
                        className="nav-link"
                      >
                        Premium Residential Proxies
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/product/isp" className="nav-link">
                        ISP Proxies
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/product/ipv6" className="nav-link">
                        IPv6 Proxies
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#purchase"
                >
                  <i className="fe fe-dollar-sign"></i> Purchase
                </Link>
                <div className="collapse" id="purchase">
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <Link to="/purchase/datacenter" className="nav-link">
                        Datacenter Proxies
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link to="/purchase/residential" className="nav-link">
                        Residential Proxies
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link
                        to="/purchase/premium-residential"
                        className="nav-link"
                      >
                        Premium Residential Proxies
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/purchase/isp" className="nav-link">
                        ISP Proxies
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/purchase/ipv6" className="nav-link">
                        IPv6 Proxies
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className={`nav-item ${!access?.isReseller && "d-none"}`}>
                <Link
                  className={tab === "balance" ? "nav-link active" : "nav-link"}
                  onClick={() => this.setState({ tab: "balance" })}
                  to="/balance"
                >
                  <i className="fe fe-dollar-sign"></i> Balance
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={
                    tab === "invoices" ? "nav-link active" : "nav-link"
                  }
                  onClick={() => this.setState({ tab: "invoices" })}
                  to="/invoices"
                >
                  <i className="fe fe-credit-card"></i> Invoices
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={tab === "faqs" ? "nav-link active" : "nav-link"}
                  onClick={() => this.setState({ tab: "faqs" })}
                  to="/faqs"
                >
                  <i className="fe fe-alert-circle"></i> FAQs
                </Link>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  rel="noreferrer"
                  target="_blank"
                  href={discord}
                >
                  <i className="fe fe-link"></i> Discord
                </a>
              </li>
              <li className="nav-item">
                <Link
                  className={
                    tab === "settings" ? "nav-link active" : "nav-link"
                  }
                  onClick={() => this.setState({ tab: "settings" })}
                  to="/settings"
                >
                  <i className="fe fe-settings"></i> Account Settings
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="#" onClick={this.logout}>
                  <i className="fe fe-log-out"></i> Logout
                </Link>
              </li>
            </ul>

            <div className="mt-auto"></div>

            <div className="navbar-user d-none d-md-flex" id="sidebarUser">
              <div className="dropup">
                <Link
                  to="#"
                  id="sidebarIconCopy"
                  className="dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div className="avatar avatar-sm avatar-online">
                    <img
                      src="/assets/img/avatars/user.png"
                      className="avatar-img rounded-circle"
                      alt="..."
                    />
                  </div>
                </Link>

                <div
                  className="dropdown-menu"
                  aria-labelledby="sidebarIconCopy"
                >
                  <Link
                    onClick={() => this.setState({ tab: "settings" })}
                    to="/settings"
                    className="dropdown-item"
                  >
                    Settings
                  </Link>
                  <hr className="dropdown-divider" />
                  <Link to="#" onClick={this.logout} className="dropdown-item">
                    Logout
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}
